import React from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
import Icon from '../Icon';
var cx;

var getIconSize = function getIconSize(size) {
  switch (size) {
    case 's':
      return '1';

    case 'l':
      return '3';

    default:
      return '2';
  }
};

var ProgressInfo = function ProgressInfo(props) {
  var qa = props.qa,
      isComplete = props.isComplete,
      unit = props.unit,
      value = props.value,
      percent = props.percent,
      size = props.size;

  var _ProgressInfo$getClas = ProgressInfo.getClassName({
    size: size
  }),
      valueClass = _ProgressInfo$getClas.value,
      unitClass = _ProgressInfo$getClas.unit;

  return isComplete ? /*#__PURE__*/React.createElement(Icon, {
    qa: "".concat(qa, "#completeIcon"),
    type: "tick",
    size: getIconSize(size),
    label: "progress completed checkmark"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#value"),
    className: valueClass
  }, unit ? value : "".concat(Math.round(percent * 100), "%")), /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#unit"),
    className: unitClass
  }, unit));
};

ProgressInfo.useClassNames = function (x) {
  ProgressInfo.classNames = x;
};

ProgressInfo.getClassName = function (_ref) {
  var size = _ref.size;
  return {
    value: cx('psw-circular-progress-percent', 'psw-t-wrap', {
      'psw-t-size-4': size === 's'
    }, {
      'psw-t-size-5': size === 'm'
    }, {
      'psw-t-size-7': size === 'l'
    }),
    unit: cx('psw-circular-progress-unit', {
      'psw-t-size-4': size === 's'
    }, {
      'psw-t-size-5': size === 'm'
    }, {
      'psw-t-size-7': size === 'l'
    })
  };
};

ProgressInfo.defaultProps = {
  qa: '',
  isComplete: false,
  unit: '',
  value: 0,
  percent: 0,
  size: 'm'
};
ProgressInfo.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Boolean true if the progress has been completed
   */
  isComplete: PropTypes.bool,

  /**
   * The value representing the progress (out of the max)
   */
  value: PropTypes.number,

  /**
   * Percent of progress completed
   */
  percent: PropTypes.number,

  /**
   * The associated unit
   */
  unit: PropTypes.string,

  /**
   * The size of the progress component
   */
  size: PropTypes.oneOf(['s', 'm', 'l'])
};
cx = classNamesFor(ProgressInfo);
export default ProgressInfo;